import { Button } from '@/components/Elements';
import user from '@/assets/anderson.png';
import loc from '@/assets/location.png';
import agency from '@/assets/agncy.png';
import { Link } from '@mui/material';
import { useState } from 'react';
import Modal from 'react-responsive-modal';
import close from '@/assets/close-circle.svg';
import docs from '@/assets/docs.png';
const Final = () => {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const handleModal = () => {
    setOpen(false);
    onOpenModal();
  };
  return (
    <div className="agency-card-row lawyer-rq fianl">
      <div className="row">
        <div className="col-12 col-lg-6 col-xl-4 mb-4">
          <div className="lawyer-boxes d-flex flex-wrap">
            <div className="lawyer-rq-icon">
              <img src={user} className="law-user-icon" />
            </div>
            <div className="lawyer-rq-cnt">
              <div className="d-flex justify-between align-items-center">
                <div className="">
                  <h5 className="text-black mb-1">Henry</h5>
                  <p className="f-13 d-flex gap-2 align-items-center">
                    <img src={loc} className="loc-icon" /> New York, USA
                  </p>
                </div>
                <span className="rejected-tx">Rejected</span>
              </div>

              <div className="row mt-3">
                <div className="col-12 col-md-5">
                  <h5 className="mb-0 text-black f-14">5484584526</h5>
                  <p className="f-13">Phone Number</p>
                </div>
                <div className="col-12 col-md-7">
                  <h5 className="mb-0 text-black f-14">Example123@gmail.com</h5>
                  <p className="f-13">Email</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 col-xl-4 mb-4">
          <div className="lawyer-boxes d-flex flex-wrap">
            <div className="lawyer-rq-icon">
              <img src={user} className="law-user-icon" />
            </div>
            <div className="lawyer-rq-cnt">
              <div className="d-flex justify-between align-items-center">
                <div className="">
                  <h5 className="text-black mb-1">Henry</h5>
                  <p className="f-13 d-flex gap-2 align-items-center">
                    <img src={loc} className="loc-icon" /> New York, USA
                  </p>
                </div>
                <span className="submitted-tx">Submitted</span>
              </div>

              <div className="row mt-3">
                <div className="col-12 col-md-5">
                  <h5 className="mb-0 text-black f-14">5484584526</h5>
                  <p className="f-13">Phone Number</p>
                </div>
                <div className="col-12 col-md-7">
                  <h5 className="mb-0 text-black f-14">Example123@gmail.com</h5>
                  <p className="f-13">Email</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 col-xl-4 mb-4">
          <div className="lawyer-boxes d-flex flex-wrap">
            <div className="lawyer-rq-icon">
              <img src={user} className="law-user-icon" />
            </div>
            <div className="lawyer-rq-cnt">
              <div className="d-flex justify-between align-items-center">
                <div className="">
                  <h5 className="text-black mb-1">Henry</h5>
                  <p className="f-13 d-flex gap-2 align-items-center">
                    <img src={loc} className="loc-icon" /> New York, USA
                  </p>
                </div>
                <span className="submitted-tx">Submitted</span>
              </div>

              <div className="row mt-3">
                <div className="col-12 col-md-5">
                  <h5 className="mb-0 text-black f-14">5484584526</h5>
                  <p className="f-13">Phone Number</p>
                </div>
                <div className="col-12 col-md-7">
                  <h5 className="mb-0 text-black f-14">Example123@gmail.com</h5>
                  <p className="f-13">Email</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 col-xl-4 mb-4">
          <div className="lawyer-boxes d-flex flex-wrap">
            <div className="lawyer-rq-icon">
              <img src={user} className="law-user-icon" />
            </div>
            <div className="lawyer-rq-cnt">
              <div className="d-flex justify-between align-items-center">
                <div className="">
                  <h5 className="text-black mb-1">Henry</h5>
                  <p className="f-13 d-flex gap-2 align-items-center">
                    <img src={loc} className="loc-icon" /> New York, USA
                  </p>
                </div>
                <span className="submitted-tx">Submitted</span>
              </div>

              <div className="row mt-3">
                <div className="col-12 col-md-5">
                  <h5 className="mb-0 text-black f-14">5484584526</h5>
                  <p className="f-13">Phone Number</p>
                </div>
                <div className="col-12 col-md-7">
                  <h5 className="mb-0 text-black f-14">Example123@gmail.com</h5>
                  <p className="f-13">Email</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="rejected-reasons  mb-4">
        <h5 className="text-black mb-4">Reject Reasons</h5>
        <h6>1. Types data we collect</h6>
        <p className="f-13">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
          sint occaecat cupidatat non proident.
        </p>
        <h6 className="mt-3">2. Use of your personal data</h6>
        <p className="f-13">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
          sint occaecat cupidatat non proident.
        </p>
      </div>

      <div className="approved-data">
      <div className="approved-colm d-flex align-items-center gap-3">
          <img src={docs} className="approve-dcs" />
          <div className="approved-col-cnt">
            <h6>Contracts & Agreements</h6>
            <p className="f-13">
              <span>23 Oct, 2023</span> <span className="ps-4">2MB</span>
            </p>
          </div>
        </div>

        <div className="approved-colm d-flex align-items-center gap-3">
          <img src={docs} className="approve-dcs" />
          <div className="approved-col-cnt">
            <h6>Contracts & Agreements</h6>
            <p className="f-13">
              <span>23 Oct, 2023</span> <span className="ps-4">2MB</span>
            </p>
          </div>
        </div>
        <div className="approved-colm d-flex align-items-center gap-3">
          <img src={docs} className="approve-dcs" />
          <div className="approved-col-cnt">
            <h6>Contracts & Agreements</h6>
            <p className="f-13">
              <span>23 Oct, 2023</span> <span className="ps-4">2MB</span>
            </p>
          </div>
        </div>
        <div className='approve-btns mt-4 d-flex gap-3 align-items-center'>
            <Button className='rounded-full'>Approved</Button>
            <Button className='rounded-full' variant='outline'>Rejected</Button>
        </div>
      </div>
    </div>
  );
};
export default Final;
